import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const dashboardManifest: FeatureManifest = {
  id: 'dashboard',
  path: 'dashboard',
  navPath: '/dashboard',
  label: 'Tổng quan',
  requiredPermissions: [],
  load: () => import('./entry'),
}
